// extracted by mini-css-extract-plugin
module.exports = {"content":"YoutubeVideo-module--content--1lxMp","margin":"YoutubeVideo-module--margin--D5-Qe","video":"YoutubeVideo-module--video--2DWHr"};